import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import '../../../../hooks/useCartDiscountsQuery/types.js';
import { useCartDiscountsQuery } from '../../../../hooks/useCartDiscountsQuery/use-cart-discounts-query.js';
import '../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import { CartDiscountSelector } from './CartDiscountSelector.js';

const CartDiscountSelectorContainer = ({ className , selectedQuantity , onCartDiscountSelection , onCartDiscountReset ,  })=>{
    const { isCartDiscountsEnabled  } = useFeatureToggles();
    const { product: { promotionIdentifier  } ,  } = useProductData();
    const { cartDiscounts , activeDiscount , loading  } = useCartDiscountsQuery(promotionIdentifier, selectedQuantity);
    if (!isCartDiscountsEnabled) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(CartDiscountSelector, {
        className: className,
        cartDiscountItems: cartDiscounts,
        isLoading: loading,
        onItemClick: onCartDiscountSelection,
        onReset: onCartDiscountReset,
        activeDiscount: activeDiscount
    });
};

export { CartDiscountSelectorContainer };
//# sourceMappingURL=CartDiscountSelectorContainer.js.map
